export const valeur = {
  id: "valeur",
  sort: false,
  padding: true,
  label: "Valeur"
}
